module.exports = __webpack_public_path__ + "static/hotblack-tech-about4-16119ff02550e85facca8cd9ae6269d9.svg";